module.exports = __webpack_public_path__ + "static/adversarial.f23dd8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/adversarial.png
// module id = 685
// module chunks = 19843951674672